import { injectable, inject } from 'inversify'
import AbstractConnect from '../../../../framework/src/connect/ajax/AbstractConnect'
import { parseURL } from '../../../../framework/src/connect/Connect'
import IConnectControl from '../../../../framework/src/connect/controllers/IConnectControl'
import FetchAjax from '../../../../framework/src/connect/FetchAjax'
import SERVICE_IDENTIFIER from '../../../../framework/src/constants/identifiers'
import SystemConfig, {
	CONFIG_PARAMS,
} from '../../../../framework/src/system/SystemConfig'
import IDOM from '../../../../framework/src/ui/IDOM'
import { IJackpotNotification } from '../interfaces/IJackpotWin'

@injectable()
export class CurrencyConvert extends AbstractConnect {
	fetchType: string = 'JokerWinCurrencyConvert'
	jackpot: IJackpotNotification

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
		@inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
		@inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
	) {
		super(config, control, fetch, dom)
		this.timeout = 3000
		this.setMethod(
			this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_CURRENCY_CONVERT_METHOD)
		)
	}
	async fetch(): Promise<IJackpotNotification> {
		this.control.reset()

		return { ...this.jackpot, ...(await this._fetch()).data }
	}
	protected getParams(): Record<string, any> {
		return {}
	}
	protected getUrl(): string {
		return parseURL(
			this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_CURRENCY_CONVERT),
			{
				currency: this.config.get(CONFIG_PARAMS.CURRENCY),
				jackpot_id: this.jackpot.jackpot_id,
			}
		)
	}
}
